module.exports = __webpack_public_path__ + "static/media/32.7ef326f0.mp3";